var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoading,
      expression: "!isLoading"
    }],
    staticClass: "splash-page splash-page--desktop",
    class: [{
      'is-backpack': _vm.isBackpack
    }],
    on: {
      "click": _vm.backgroundClick
    }
  }, [_c('div', {
    staticClass: "splash-page-modal-top-nav-close splash-page__nav-close",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.closeClick.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('header'),
      expression: "verifyModuleVisibility('header')"
    }],
    class: ['splash-page__header-tools', _vm.regionIsApac ? 'splash-page__header-tools--apac' : '']
  }, [_c('img', {
    staticClass: "splash-page__arrow splash-page__arrow--tools",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/swipe-to-access-arrow-step3.png")
    }
  }), _c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('headerTools')))])]), _c('div', {
    staticClass: "splash-page__logo",
    class: [_vm.regionIsApac ? 'splash-page__logo--apac' : '']
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/customs-logo.png")
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('rotate'),
      expression: "verifyModuleVisibility('rotate')"
    }],
    staticClass: "splash-page__instruction splash-page__instruction--rotate",
    style: {
      opacity: _vm.opacity
    }
  }, [_c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(" " + _vm._s(this.getRotateTranslation()) + " ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('rotate'),
      expression: "verifyModuleVisibility('rotate')"
    }],
    staticClass: "splash-page__component",
    class: [{
      'splash-page__component--backpack': _vm.isBackpack,
      'splash-page__component--apparel': _vm.isApparel,
      'splash-page__component--apac': _vm.regionIsApac
    }],
    style: {
      opacity: _vm.opacity
    }
  }, [_vm._t("default"), _c('div', {
    ref: "rotateUp",
    staticClass: "splash-page__rotate splash-page__rotate--up",
    class: {
      'rotate-up--is-backpack': _vm.isBackpack,
      'is-apac': _vm.regionIsApac
    }
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/rotate-up.png")
    }
  })]), _c('div', {
    ref: "rotateDown",
    staticClass: "splash-page__rotate splash-page__rotate--down",
    class: [{
      'rotate-down--is-backpack': _vm.isBackpack,
      'is-apac': _vm.regionIsApac
    }]
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/rotate-down.png")
    }
  })])], 2), _c('div', {
    staticClass: "skip-cta splash-page__skip",
    class: [_vm.regionIsApac ? 'splash-page__skip--apac' : '']
  }, [_c('button', {
    staticClass: "splash-page__label",
    on: {
      "click": _vm.onSkip
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getTranslation('skipToGetStarted')) + "\n    ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('faqs'),
      expression: "verifyModuleVisibility('faqs')"
    }],
    class: ['splash-page__faqs', 'checkout-faqs', _vm.regionIsApac ? 'splash-page__faqs--apac' : '']
  }, [_c('button', {
    staticClass: "splash-page__label",
    attrs: {
      "id": "faqs"
    },
    on: {
      "click": _vm.faqsAction
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getTranslation('faqs')) + "\n    ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('all_parts'),
      expression: "verifyModuleVisibility('all_parts')"
    }],
    ref: "partsCustomize",
    staticClass: "see-all-customize-parts splash-page__all-customize-parts"
  }, [_c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('allParts')))]), _c('img', {
    staticClass: "splash-page-desktop__arrow",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/parts-customize-arrow-down.png")
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('tabs'),
      expression: "verifyModuleVisibility('tabs')"
    }],
    staticClass: "add-your-own-all splash-page__add-your-own"
  }, [_c('label', {
    staticClass: "splash-page__label"
  }, [_vm._v(_vm._s(_vm.getTranslation('addYourOwn')))]), _c('img', {
    staticClass: "splash-page-desktop__arrow",
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/add-your-own-arrow-step2.png")
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }